import { IonButton, useIonModal, useIonToast } from '@ionic/react';
import { EmptyBlock, User } from 'model';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../App';
import { useBlockUserMutation, useGetBlockForUserByUserToBlockQuery, useUnBlockUserMutation } from '../api/BlockApi';
import { Confirmation } from '../pages/Confirmation';
import { LoginState } from '../state/loginSlice';
import { ProfilePic } from './ProfilePic';
// eslint-disable-next-line css-modules/no-unused-class
import sharedstyles from '../styles/Shared.module.css';
import { IconButton } from './IconButton';
import { IconDeactivate } from './QuirkIcons';
interface blockListUserType {
	userToBlock: User;
	type?: 'menu';
	action?: () => void;
	onBlockUser?: () => void;
	onUnBlockUser?: () => void;
}
export const BlockUser: React.FC<blockListUserType> = ({ userToBlock, type, action, onBlockUser, onUnBlockUser }) => {
	// check if user is self, can't block self
	const state: LoginState = useSelector<RootState, LoginState>(state => state.login);
	const [isBlocked, setIsBlocked] = useState(false);
	const blockable = state.user._id && userToBlock?._id && state.user._id !== userToBlock._id;
	const didIBlockThisUser = useGetBlockForUserByUserToBlockQuery(userToBlock._id);

	const [blockUser] = useBlockUserMutation();
	const [unBlockUser] = useUnBlockUserMutation();

	useEffect(() => {
		if (didIBlockThisUser?.data?._id && didIBlockThisUser.data._id !== EmptyBlock._id) {
			setIsBlocked(true);
		} else {
			setIsBlocked(false);
		}
	}, [didIBlockThisUser?.data?._id]);

	const id = userToBlock._id;

	const handleBlockUser = () => {
		setIsBlocked(!isBlocked);

		if (isBlocked) {
			onUnBlockUser?.();
			presentBlocked({
				color: 'success',
				message: 'User has been unhidden',
				position: 'top',
				duration: 1500
			});
			dismiss();
			unBlockUser({ userToBlock: id });
		} else {
			onBlockUser?.();
			presentBlocked({
				color: 'danger',
				message: 'User has been hidden',
				position: 'top',
				duration: 1500
			});
			dismiss();
			blockUser({ userToBlock: id });
		}
	};

	const [present, dismiss] = useIonModal(Confirmation, {
		onDismiss: () => dismiss(),
		action: () => handleBlockUser(),
		actionLabel: isBlocked ? 'Unhide User' : 'Hide User',
		dismissLabel: 'Cancel',
		content: (
			<>
				<div className={sharedstyles.userContainer}>
					<ProfilePic user={userToBlock} />
					<div className="fullwidth">
						<div>{userToBlock.username}</div>
					</div>
				</div>
				<h4 style={{ marginBottom: '40px' }}>
					{`Are you sure you want to ${isBlocked ? 'unhide ' : 'hide '}`}
					<span className={sharedstyles.highlight}>{userToBlock.username}</span>?
				</h4>
			</>
		)
	});

	const [presentBlocked] = useIonToast();

	return (
		<>
			{blockable && (
				<>
					{type === 'menu' ? (
						<IconButton
							data-testid="blockUserButton"
							label={isBlocked ? 'Unhide User' : 'Hide User'}
							icon={<IconDeactivate />}
							onClick={() => {
								present();
								action && action();
							}}
						/>
					) : (
						<IonButton
							expand="block"
							color={'primary'}
							fill="outline"
							size="small"
							className="radius8"
							data-testid="blockUserButton"
							onClick={() => present()}
						>
							{isBlocked ? 'Unhide User' : 'Hide User'}
						</IonButton>
					)}
				</>
			)}
		</>
	);
};
